type TItem = {
  key: string
  value: string
}

/**
 * Guarda pares clave/valor en localStorage.
 *
 * Se usa principalmente para persistir access token y refresh token entre
 * recargas del navegador. No debe usarse para almacenar datos sensibles nuevos
 * sin revisar el riesgo de exposicion ante XSS.
 */
export const setItemsLocalStorage = (items: TItem[]) => {
  items.forEach(i => {
    localStorage.setItem(i.key, i.value)
  })
}

export const getItemLocalStorageByKey = (key: string): string | null => localStorage.getItem(key)

/**
 * Elimina claves de localStorage al cerrar sesion o invalidar credenciales.
 */
export const deleteItemLocalStorageByKeys = (keys: string[]) => keys.forEach(k => localStorage.removeItem(k))
